import React, { Component } from "react";
import Loadable from 'react-loadable';
import moment from 'moment'
import isEqual from 'lodash/isEqual'

import { connect } from "react-redux";
import * as actions from "./../../actions";

import PropTypes from 'prop-types';

import { withStyles} from '@material-ui/core/styles';

import NavBar from './../navs/NavBar'
import LandingPage from './LandingPage'
import CustomLandingPage from './CustomLandingPage'

import ProductsPage from './ProductsPage'

import Footer from './Footer'
import BetAdvices from "./BetAdvices"
import Preloader from "./../reusableComponents/Preloader"

import Fade from '@material-ui/core/Fade';
import CookieConsent from './../reusableComponents/CookieConsent'
import AboutCookies from './AboutCookies'

import {Element , animateScroll as scroll, scroller } from 'react-scroll'

const StatisticPage = Loadable({
  loader: () => import('./StatisticPage'),
  loading: ()=>{return(
    <div style={{height:"100vh", width:"100%", background:"rgba(255,255,255,0.9)"}}></div>
  )}
});

const styles = theme => ({
  root:{

  },

})

class Main extends Component{

  state = {
    showStatistic: false,
  }


  componentDidMount(){
    window.addEventListener('scroll',this.handleScroll)
    if(this.props.navigationData){

      if(this.props.navigationData){
        setTimeout(()=>{
          scroller.scrollTo(this.props.navigationData, {
            duration: 1200,
            delay: 150,
            smooth: "easeInOutQuint",
            offset: this.props.navigationData === "packages" ? -120 : 0,

          }, 1000)
        })

      }
    }



  }

  componentDidUpdate(prevProps){
    if(prevProps.transactionInProccess !== this.props.transactionInProccess)this.setState({transactionInProccess: this.props.transactionInProccess})

    if(!isEqual(prevProps.navigationData, this.props.navigationData)){

      if(this.props.navigationData === "top"){
        scroll.scrollToTop()
      }if(this.props.navigationData === "betVideos"){
        this.context.router.history.push("/brezplacninasveti")
      }else if(this.props.navigationData){

        scroller.scrollTo(this.props.navigationData, {
          duration: 1200,
          delay: 150,
          smooth: "easeInOutQuint",
          offset: this.props.navigationData === "packages" ? -120 : 0,

        })
      }
    }



  }


  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);

  }




  handleScroll = () => {

    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    let scroll = {
       x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
       y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    };

    let scrollTopOffset = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

    if(scrollTopOffset > 300){
      if(!this.state.showStatistic)this.setState({showStatistic: true})
    }

  }


  navCallback = (link)=>{

  }

  static contextTypes = {
    router: PropTypes.object
  }

  render(){
    const {freeBetPageData} = this.props

    if(this.props.freeBetPageData !== "loading" && this.props.fetchAllProductsOnce !== "loading" && this.props.fetchPackageStatisticOnce !== "loading"){
      return(
        <Fade in={true} timeout={500}>
          <div   className={this.props.classes.root} >
              {
                this.state.transactionInProccess && (

                    <div style={{position: "fixed", top: 0, left: 0, width: "100%", height:"100vh", opacity: 1, zIndex: 10000}}>
                      <Preloader  />
                    </div>


                )
              }
              <AboutCookies />
              <CookieConsent />
              <NavBar callback={this.navCallback}/>

                <Element  name="home" >
                  {
                    (freeBetPageData.active && moment().isBetween(moment.unix(freeBetPageData.dateFrom), moment.unix(freeBetPageData.dateTo), null, [])) ? (
                      <CustomLandingPage />
                    ):(
                      <LandingPage />
                    )
                  }
                </Element>
                <Element name="packages">
                  <ProductsPage />
                </Element>
                <Element name="statistic">
                  {this.state.showStatistic ? (
                    <Fade in={this.state.showStatistic}>
                      <StatisticPage showTitle={true} timeout={500}/>
                    </Fade>

                  ) : <div style={{height:"100vh", width:"100%", background:"rgba(255,255,255,0.9)"}}></div>}
                </Element>
                <Element name="advices">
                  <BetAdvices/>
                </Element>

              <Footer />

          </div>
        </Fade>
      )
    }else{
      return <Preloader />
    }

  }
}

Main.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ freeBetPageData, fetchAllProductsOnce, fetchPackageStatisticOnce, navigationData, auth, transactionInProccess }) => {
  return {
    freeBetPageData,
    fetchAllProductsOnce,
    fetchPackageStatisticOnce,
    navigationData,
    auth,
    transactionInProccess
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(Main))



// WEBPACK FOOTER //
// ./src/components/main/Main.js